/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, mp */

/*
 * Provides:
 *  mp.widgets.dropdowns.Rounded
 *
 * Requires:
 *  mp.widgets.dropdowns.base
 *  mp.widgets.dropdowns.styled_labels
 */

_.namespace(`mp.widgets.dropdowns`, function(ns) {
  'use strict';

  function Rounded() {
    this.class_name = `rounded_dropdown`;
    this.label_class = mp.widgets.styled_labels.Rounded;
    this.body_class = Body;
  }
  _.inherit(Rounded, mp.widgets.Dropdown);

  Rounded.prototype.default_config = function() {
    return _.extend(Rounded.superclass.default_config.call(this), {
      emulate_select: true,
    });
  };

  function Body() {
    this.class_name = `rounded_dropdown_body`;
    this.item_class = Item;
  }
  _.inherit(Body, mp.widgets.Dropdown.Body);

  Body.prototype.label_changed = function(ev, label) {
    this.container.css(`min-width`, label.container.outerWidth() - 2);
  };

  function Item() {
    this.class_name = `rounded_dropdown_item`;
  }
  _.inherit(Item, mp.widgets.Dropdown.Item);

  Item.prototype.create = function() {
    Item.superclass.create.apply(this, arguments);

    if (this.config.type_icons) {
      this.icon_container = $(`<div>`).addClass(`icon_container`);
      this.content = $(`<div>`).addClass(`word_container`);
      this.container.append(this.icon_container);

      if (this.config.second_type_icon) {
        this.second_icon_container = $(`<div>`).addClass(`second_icon_container`);
        this.container.append(this.second_icon_container);
      }
      this.container.append(this.content);
    } else {
      this.content = this.container;
    }

    return this;
  };

  Item.prototype.default_config = function() {
    return {
      type_icons: false,
    };
  };

  Item.prototype._set_content = function(item) {
    if (_.isArray(item)) {
      this.display_value = item[1];
      this.tooltipData = item[3] || null;
      this.titleTooltip = item[4];
      this.disabled = item[5];
    } else {
      this.display_value = item;
      this.tooltipData = null;
      this.titleTooltip = null;
    }
    this.content.text(this.display_value).attr(`title`, this.titleTooltip ? this.titleTooltip : this.display_value);

    if (this.config.type_icons) {
      if (item.length >= 3) {
        this.icon_container.addClass(item[2]);
        this.type = item[2];
      } else {
        this.icon_container.addClass(`unknown`);
        this.type = `unknown`;
      }
    }
    if (this.disabled) {
      this.disable();
    }
  };

  Rounded.Label = mp.widgets.styled_labels.Rounded;
  Rounded.Body = Body;
  Rounded.Item = Item;

  return {
    Rounded,
  };
});

}.call(window));